import { ContratoStatus, VersaoContratoEnum } from 'models/contratos';
import { Action, ContratosAssessoresReducerState } from './__types';
import {
  CHANGED_CONTRATO_ASSESSOR_EDITING_VALUE_ACTION,
  CLEAR_COD_COOP_ACTION,
  CLEARED_CONTRATO_ASSESSOR_ACTION,
  CLOSE_MODAL_ADITIVO,
  CLOSE_MODAL_DISTRATO,
  LOADED_CONTRATO_ASSESSOR_ACTION,
  OPEN_MODAL_ADITIVO,
  OPEN_MODAL_DISTRATO,
  SET_CONTRATO_ID_ACTION,
} from './AssessoresActions';

const CONTRATO_EDITING_INITIAL_STATE = {
  ativo: false,
  codCoop: '',
  emailCoop: '',
  cpfAssessores: [],
  programasEducacionais: [],
  idEmpresa: 0,
  cnpjEmpresa: '',
  reembolso: '',
  valorAssessoria: 0,
  valorReuniao: 0,
  valorFormacao: 0,
  valorOutros: 0,
  htmlContrato: '',
  dataInicio: '',
  dataFim: '',
  totalMeses: 0,
  dataDistrato: '',
  flgStatus: ContratoStatus.EM_EDICAO,
  valorReembolsoHospedagem: null,
  valorReembolsoAlimentacao: null,
  valorReembolsoDeslocamento: null,
  valorReembolsoPedagio: null,
  valorReembolsoOutros: null,
  reembolsoOutrosDescricao: '',
  reembolsoObservacoes: '',
  flgAnaliseJuridica: false,
  idContrato: null,
  versaoContrato: VersaoContratoEnum.CONTRATO,
};

const INITIAL_STATE: ContratosAssessoresReducerState = {
  contratoEditing: CONTRATO_EDITING_INITIAL_STATE,
  isModalAditivoOpen: false,
  isModalDistratoOpen: false,
};

export default function contratosDescentralizadosAssessoresReducer(
  state: ContratosAssessoresReducerState = INITIAL_STATE,
  action: Action
): ContratosAssessoresReducerState {
  switch (action.type) {
    case CLEAR_COD_COOP_ACTION:
      return {
        ...state,
        contratoEditing: {
          ...state.contratoEditing,
          codCoop: '',
        },
      };
    case CLEARED_CONTRATO_ASSESSOR_ACTION:
      return {
        ...state,
        contratoEditing: CONTRATO_EDITING_INITIAL_STATE,
      };
    case CHANGED_CONTRATO_ASSESSOR_EDITING_VALUE_ACTION:
      return {
        ...state,
        contratoEditing: {
          ...state.contratoEditing,
          [action.payload.name]: action.payload.value,
        },
      };
    case SET_CONTRATO_ID_ACTION:
      return {
        ...state,
        contratoEditing: {
          ...state.contratoEditing,
          idContrato: action.payload,
        },
      };
    case LOADED_CONTRATO_ASSESSOR_ACTION:
      return {
        ...state,
        contratoEditing: {
          ...CONTRATO_EDITING_INITIAL_STATE,
          ...action.payload,
        },
      };
    case OPEN_MODAL_ADITIVO:
      return { ...state, isModalAditivoOpen: true };
    case CLOSE_MODAL_ADITIVO:
      return { ...state, isModalAditivoOpen: false };
    case OPEN_MODAL_DISTRATO:
      return { ...state, isModalDistratoOpen: true };
    case CLOSE_MODAL_DISTRATO:
      return { ...state, isModalDistratoOpen: false };
    default:
      return state;
  }
}
